import React, { useEffect, useState } from 'react';
import { HomeOutline, HeartOutline, Add } from 'react-ionicons';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import { SideBar } from '../../Containers/Containers';
import Menu from '../../Menu/Menu';
import Dropdown from '../Dropdown/Dropdown';
import MenuOptions from '../MenuOptions/MenuOptions';
import Recent from '../Recent/Recent';
import {
  Row,
  SidebarHeader,
  OptionContainer,
  OptionBox,
  Title,
  Divider,
} from './SidebarComponents';
import logo from './Artboard_2.png';
import { useDispatch, useSelector } from 'react-redux';
import { setMenuOpenedState } from '../../../store/features/adminSlice';
import routes from '../../../router/routes';
/**
 * @component
 *  the main sidebar component which renders on almost all screens
 * @example <SidebarContent />
 * @returns {void}
 */
const SidebarContent = () => {
  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  const [fullSidebar, setFullSidebar] = useState(false);
  const [showSidebar, setshowSidebar] = useState(true);
  const [isEditOrAdd, setIsEditOrAdd] = useState(true);
  const [isManual, setIsManual] = useState(false);
  const [showMenuOptions, setShowMenuOptions] = useState(false);
  const loggedIn = useSelector((state) => state.admin.isLoggedIn);
  const isMenuIsOpened = useSelector((state) => state.admin.isMenuIsOpened);

  /**
   * useEffect used to verify current URL for conditional displays whitin the sidebar
   */
  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];

    currentPathName.includes('acerca') ||
    currentPathName.includes('agregar') ||
    currentPathName.includes('privacidad') ||
    currentPathName.includes('edit') ||
    currentPathName.includes('terminos')
      ? setFullSidebar(true)
      : setFullSidebar(false);

    currentPathName.includes('login')
      ? setshowSidebar(false)
      : setshowSidebar(true);

    currentPathName.includes('acerca') ||
    currentPathName.includes('privacidad') ||
    currentPathName.includes('terminos')
      ? setShowMenuOptions(true)
      : setShowMenuOptions(false);

    currentPathName.includes('edit') || currentPathName.includes('agregar')
      ? setIsEditOrAdd(true)
      : setIsEditOrAdd(false);

    currentPathName.includes('manual') ? setIsManual(true) : setIsManual(false);
  }, [location]);

  /**
   *  toggles the display of the meatball menu.
   * @returns {void}
   */
  const toggleShowMenu = (e) => {
    isMenuIsOpened
      ? dispatch(setMenuOpenedState(false))
      : dispatch(setMenuOpenedState(true));
  };

  useEffect(() => {
    dispatch(setMenuOpenedState(false));
  }, [dispatch, location]);

  const showEditOptions = () => (
    <NavLink
      activeStyle={{ color: '#fff', fontWeight: 500 }}
      to={routes.addStation}
      onClick={toggleShowMenu}
      style={{
        display: 'flex',
        width: '100%',
        color: '#fff',
        userSelect: 'none',
        fontSize: '16px',
        fontWeight: '500',
        textDecoration: 'none',
        paddingTop: '13px',
      }}>
      Agregar emisora
    </NavLink>
  );

  return (
    <SideBar
      style={{
        height: loggedIn || fullSidebar ? '100%' : '',
        display: showSidebar ? 'flex' : 'none',
        background:
          'linear-gradient(180deg,hsla(208,87% 34%,1)45%,hsla(212, 100%,23%,1))0%',
      }}>
      <SidebarHeader>
        <Row>
          <img
            src={logo}
            alt="logo de la institucion"
            style={{
              height: '38px',
              width: '38px',
              transform: 'translate(4px, 17px)',
            }}
          />
          {true ? (
            <>
              <Menu toggler={toggleShowMenu} />
              <Dropdown show={isMenuIsOpened} toggler={toggleShowMenu} />
            </>
          ) : null}
        </Row>
      </SidebarHeader>
      <OptionContainer onClick={() => dispatch(setMenuOpenedState(false))}>
        <OptionBox
          style={{
            marginLeft: '20px',
            width: loggedIn || showMenuOptions ? '100%' : '',
            height: '50px',
            marginBottom: loggedIn ? '1px' : '-10px',
            marginTop: loggedIn ? '5px' : '15px',
            paddingRight: loggedIn && !showMenuOptions ? '10px' : '',
          }}>
          <div
            style={{
              margin: 0,
              padding: 0,
              marginLeft: '0',
              paddingTop: loggedIn ? '5px' : '',
            }}>
            {(!loggedIn && showMenuOptions) ||
            (loggedIn && showMenuOptions) ||
            (loggedIn && isEditOrAdd) ||
            !loggedIn ? (
              <NavLink
                style={{
                  opacity: '0.8',
                }}
                exact={true}
                activeStyle={{ opacity: 1, color: '#fff' }}
                to={routes.home}>
                <HomeOutline height="28px" width="28px" color="#fff" />
              </NavLink>
            ) : !isManual ? (
              <Add
                style={{
                  opacity: '1',
                  marginTop: '-2px',
                  paddingTop: '6px',
                  marginLeft: '-5px',
                }}
                height="28px"
                width="28px"
                color="#fff"
              />
            ) : (
              <NavLink
                style={{
                  opacity: 1,
                  marginTop: '5px',
                }}
                exact={true}
                activeStyle={{ opacity: 1, color: '#fff' }}
                to={routes.admin}>
                <HomeOutline height="28px" width="28px" color="#fff" />
              </NavLink>
            )}
          </div>
          {showMenuOptions && !loggedIn ? (
            <Title>
              <NavLink
                activeStyle={{
                  opacity: '1 !important',
                  color: '#fff',
                  opacity: 1,
                  fontWeight: '500',
                }}
                to={routes.home}
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '17px',
                  marginTop: '-10px',
                  opacity: '0.7',
                }}>
                Volver al inicio
              </NavLink>
            </Title>
          ) : (loggedIn && isEditOrAdd) || isManual ? (
            <Title>
              <NavLink
                activeStyle={{
                  opacity: '1 !important',
                  color: '#fff',
                  fontWeight: '500',
                }}
                to={routes.admin}
                style={{
                  display: 'flex',
                  width: '100%',
                  color: '#fff',
                  userSelect: 'none',
                  fontSize: '16px',
                  fontWeight: '500',
                  textDecoration: 'none',
                  marginBottom: '3px',
                }}>
                Volver <br /> a gestión
              </NavLink>
            </Title>
          ) : loggedIn && !showMenuOptions ? (
            showEditOptions()
          ) : setShowMenuOptions && loggedIn ? (
            <Title>
              <NavLink
                activeStyle={{
                  opacity: '1 !important',
                  color: '#fff',
                  opacity: 1,
                  fontWeight: '500',
                }}
                to={routes.admin}
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '16px',
                  opacity: '0.7',
                }}>
                Volver al inicio
              </NavLink>
            </Title>
          ) : !loggedIn ? (
            <Title>
              <NavLink
                activeStyle={{
                  color: '#fff',
                  opacity: 1,
                  fontWeight: '500',
                }}
                to={routes.home}
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '17px',
                  paddingBottom: '15px',
                  paddingLeft: '1px',
                  opacity: '0.7',
                }}>
                Inicio
              </NavLink>
            </Title>
          ) : null}
        </OptionBox>
        {loggedIn || showMenuOptions ? null : (
          <OptionBox
            onClick={() => history.push(routes.favorites)}
            style={{ paddingLeft: '7px', marginBottom: '20px' }}>
            <NavLink
              activeStyle={{ opacity: 1 }}
              to={routes.favorites}
              style={{
                margin: 0,
                padding: 0,
                marginLeft: 'auto',
                opacity: '0.8',
                paddingLeft: '13px',
              }}>
              <HeartOutline height="28px" width="28px" color="#fff" />
            </NavLink>
            <Title>
              <NavLink
                activeStyle={{
                  color: '#fff',
                  opacity: 1,
                  fontWeight: '500',
                }}
                to={'/favoritos'}
                style={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '17px',
                  paddingBottom: '15px',
                  paddingLeft: '1px',
                  opacity: '0.7',
                  paddingTop: '4px',
                }}>
                Favoritos
              </NavLink>
            </Title>
          </OptionBox>
        )}
      </OptionContainer>
      <Divider />
      {(loggedIn && showMenuOptions) || loggedIn || showMenuOptions ? null : (
        <Title
          style={{
            marginRight: '43px',
            opacity: '1',
            fontWeight: '400',
            fontSize: '15px',
            paddingTop: '5px',
          }}>
          Escuchados <br />
          recientemente
        </Title>
      )}
      <div
        onClick={() => dispatch(setMenuOpenedState(false))}
        style={{ width: '100%', marginBottom: '10px' }}>
        {showMenuOptions ? (
          <MenuOptions />
        ) : !loggedIn && !showMenuOptions ? (
          <Recent />
        ) : null}
      </div>
    </SideBar>
  );
};

export default SidebarContent;
